export default {
  SET_KETHER_PLOT_INFO(state, info) {
    state.kether.plotInfo = info;
  },

  SET_KETHER_PLOT_AGG_DATA_INFO(state, aggData) {
    state.kether.plotInfoAggregateData = aggData;
  },
};
